import React from 'react'
import ReactDOM from 'react-dom'
import videojs from 'video.js'

const vjsComponent = videojs.getComponent('Component')

export default class BackToSceneButton extends vjsComponent {
    constructor(player, options) {
        super(player, options)
        this.state = {
            backToScene: options.backToScene,
        }

        /* Bind the current class context to the mount method */
        this.mount = this.mount.bind(this)

        /* When player is ready, call method to mount React component */
        player.ready(() => {
            this.mount()
        })

        /* Remove React root when component is destroyed */
        this.on('dispose', () => {
            ReactDOM.unmountComponentAtNode(this.el())
        })
    }

    mount() {
        const { backToScene } = this.state
        ReactDOM.render(
            <button onClick={backToScene}>
                <div>{'Back to Scene'}</div>
            </button>,
            this.el()
        )
    }
}
